import PageViewLayout from '@/components/layouts/PageViewLayout/PageViewLayout';
import InjectionNoticeContent from '@/components/modules/pages/articles/InjectionNoticeContent';
import SEO, { seoPropsFromBaseString } from '@/components/modules/SEO';
import { SCREEN_NAME } from '@/constants/analytics';
import { trackPage, url } from '@/helpers';
import { trackScreenShown } from '@/hooks/useTrackScreenShown';
import { _s } from '@/locale';
import { useEffect } from 'react';

const InjectionNotice = () => {
  useEffect(() => {
    trackPage();
    trackScreenShown({ screen_name: SCREEN_NAME.INJECTION_NOTICE });
  }, []);

  return (
    <PageViewLayout type="subView" back title={_s('injectionNoticeTitle')}>
      <div className="container py-4">
        <InjectionNoticeContent />
      </div>
      <SEO {...seoPropsFromBaseString('injectionNotice', url.getBaseUrl() + 'articles/injection-notice')} />
    </PageViewLayout>
  );
};

export default InjectionNotice;
